// Types for theater preferences
import { ApolloError } from '@apollo/client'
import { E164Number } from 'libphonenumber-js'
import { TheatricalShowtimeVenue, UserPreference, TheatricalAddress } from '@/types/codegen-federation'

// Define the input types based on the GraphQL schema
export interface TheaterPreferenceInput {
  id: string
  priority: number
}

export interface TimeRangeInput {
  start: string
  end: string
}

export interface DayPreferenceInput {
  day: string
  timeRanges: TimeRangeInput[]
}

export interface UserPreferenceInput {
  theaterPreferences: TheaterPreferenceInput[]
  dayPreferences?: DayPreferenceInput[]
  autobookEnabled?: boolean
  phoneNumber?: string
  timezone?: string
}

// Theater information interface
export interface TheaterInfo {
  id: string
  name: string
  address?: string
  distance?: string
  phone?: string
}

// Steps for the modal
export enum PreferenceStep {
  THEATER_SELECTION = 'theater_selection',
  VIEW_EXISTING_PREFERENCES = 'view_existing_preferences',
}

export interface Coordinates {
  latitude: number
  longitude: number
}

export interface TheaterPreferencesModalProps {
  isOpen: boolean
  onClose: () => void
}

export interface TheaterPreferencesContextType {
  preferencesData: UserPreference | null
  defaultAddressString: string
  location: string
  coordinates: Coordinates | null
  selectedVenueId: string
  selectedTheater: TheaterInfo | null
  dayTimePreferences: Record<string, string[]>
  hasExistingPreferences: boolean
  preferencesLoading: boolean
  loading: boolean
  venues: TheatricalShowtimeVenue[]
  venuesLoading: boolean
  venuesError: ApolloError | null
  userLocation: TheatricalAddress | undefined
  phoneNumber: E164Number | undefined
  setPhoneNumber: (phone: E164Number | undefined) => void
  setAutobookEnabled: (enabled: boolean) => void
  handleAddressChange: (coords: Coordinates, searchString: string) => void
  handleVenueSelect: (venueId: string, venueData?: TheatricalShowtimeVenue) => void
  handleDayTimeToggle: (dayId: string, timeWindowId: string) => void
  handleSave: () => Promise<void>
  handleSaveVenuePreferenceOnly: (venueId: string) => Promise<void>
}
